import React, { useState, useEffect } from "react";
import "./../styles/global.scss";
import IndexPage from "./index";
import AuthSigninPage from "./authsignin";
import AuthSignupPage from "./authsignup";
import ForgotPasswordPage from "./forgotpassword";
import GeneralSettingsPage from "./GeneralSettingsPage";
import PasswordSettingsPage from "./PasswordSettingsPage";
import HelpPage from "./help";
import BlogPage from "./blog";
import ReportsPage from "./ReportsPage";
import ManagePage from "./ManagePage";
import BillingPage from "./BillingPage";
import { Switch, Route, Router, Redirect } from "./../util/router.js";
import "./../util/analytics.js";
import { ProvideAuth, useAuth } from "./../util/auth.js";
import { ProvideUser } from "./../util/payments.js";
import PricingPage from "./pricing";


function App(props) {
  

  return (
    <ProvideAuth>
      <ProvideUser>
      <Router>
        <Switch>
          <Route exact path="/" component={IndexPage} />

          <Route exact path="/auth/signin" component={AuthSigninPage} />

          <Route exact path="/auth/signup" component={AuthSignupPage} />

          <Route exact path="/auth/forgotpass" component={ForgotPasswordPage} />

          <Route exact path="/settings/general" component={GeneralSettingsPage} /> 

          <Route exact path="/settings/password" component={PasswordSettingsPage} /> 

          <Route exact path="/dashboard" render={(props) => <ReportsPage {...props} />} />
          
          <Route exact path="/manage" render={(props) => <ManagePage {...props} />} />

          <Route exact path="/pricing" render={(props) => <PricingPage {...props} />} />

          <Route exact path="/billing" render={(props) => <BillingPage {...props} />} />

          <Route
            component={({ location }) => {
              return (
                <div
                  style={{
                    padding: "50px",
                    width: "100%",
                    textAlign: "center"
                  }}
                >
                  The page <code>{location.pathname}</code> could not be found.
                </div>
              );
            }}
          />
        </Switch>
      </Router>
    </ProvideUser>
    </ProvideAuth>
  );
}

          /* <Route exact path="/help" component={HelpPage} />

          <Route exact path="/blog" component={BlogPage} /> */
export default App;
